import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';



@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const user = localStorage.getItem('user');
        if(user != null)
        { 
            let now = new Date();  
            let jsontoken = JSON.parse(user);
            let expired = new Date(jsontoken.expiredAt);
            if(now < expired){
                return true
            }else{
                this.router.navigate(['']);
                return false;
            }
        }else{
            this.router.navigate(['']);
            return false;
        }
    }

    
}